import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QbService {
  _loading = false;
  // get loading() {
  //   return  this._loading;
  // }
  set loading(val: boolean) {
    setTimeout(() => {
      this._loading = val;
      this._loading$.next(val);
    });
  }
  _loading$ = new BehaviorSubject<boolean>(this._loading);
  get loading$() {
    return this._loading$.asObservable();
  }

  constructor() {}
}
